import type { FC } from "react";
import { useTranslation } from "@privacy/translations";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DynamicForm } from "../../../dynamicForm";
import { TenantIcon3, LockIcon } from "../../../shared/icons";
import { EmptyPlaceholderText } from "../../../dynamicForm/inlineForm/EmptyPlaceholderText";

export const ConnectedProcessor: FC<{ name?: string }> = ({ name }) => {
  const { t } = useTranslation();

  return (
    <DynamicForm.InlineFieldPrimary
      label={t("RegistrationDrawer.Connected.Processor.Label")}
      infoPopoverContent={{
        title: t("RegistrationDrawer.Connected.Processor.InfoPopoverHeader"),
        body: t("RegistrationDrawer.Connected.Processor.InfoPopoverContent"),
      }}
      input={
        <Stack direction="row" spacing={1} sx={{ pl: 2, alignItems: "center" }}>
          {name ? (
            <>
              <TenantIcon3 size={16} />
              <Typography sx={{ fontSize: theme => theme.typography.pxToRem(14) }}>{name}</Typography>
              <LockIcon size={10} strokeWidth={2.5} color={theme => theme.palette.text.tertiary} />
            </>
          ) : (
            <EmptyPlaceholderText />
          )}
        </Stack>
      }
    />
  );
};
